<template>
  <b-modal
    :id="modalId"
    ref="modal"
    hide-header
    hide-footer
    centered
    body-class="p-0 overflow-hidden"
    @hidden="onHidden"
  >
    <!-- Custom Premium Header -->
    <div class="modal-header-premium bg-gradient-primary text-white p-3 d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div class="icon-box-premium mr-3">
          <i class="fa fa-cube"></i>
        </div>
        <div>
          <h5 class="mb-0 font-weight-bold">{{ title }}</h5>
          <small class="opacity-80">Informe os detalhes do volume transportado</small>
        </div>
      </div>
      <button type="button" class="close text-white opacity-100" @click="$refs.modal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="p-4">
      <b-form v-if="local">
        <fieldset :disabled="!canEdit" class="border-0 p-0 m-0">
        <b-row>
          <b-col md="4">
            <b-form-group label="* Quantidade" label-class="modal-label-premium">
              <b-form-input 
                v-model.number="local.NR_QUANTIDADE" 
                type="number" 
                min="1"
                class="rounded-pill shadow-xs"
              />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="* Espécie" label-class="modal-label-premium">
              <b-form-input v-model="local.TX_ESPECIE" maxlength="60" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>

          <b-col md="4">
            <b-form-group label="Marca" label-class="modal-label-premium">
              <b-form-input v-model="local.TX_MARCA" maxlength="60" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group label="Numeração" label-class="modal-label-premium">
              <b-form-input v-model="local.TX_NUMERACAO" maxlength="60" class="rounded-pill shadow-xs" />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Peso Líquido (KG)" label-class="modal-label-premium">
              <b-form-input 
                v-model.number="local.NR_PESO_LIQUIDO" 
                type="number" 
                step="0.001"
                min="0"
                class="rounded-pill shadow-xs"
              />
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group label="Peso Bruto (KG)" label-class="modal-label-premium">
              <b-form-input 
                v-model.number="local.NR_PESO_BRUTO" 
                type="number" 
                step="0.001"
                min="0"
                class="rounded-pill shadow-xs"
              />
            </b-form-group>
          </b-col>
        </b-row>
        </fieldset>

        <!-- Custom Footer -->
        <div class="modal-footer-premium bg-light border-top p-3 d-flex justify-content-end mx-n4 mb-n4 mt-4">
          <b-button variant="light" @click="$refs.modal.hide()" class="btn-glass mr-2 px-4">
            <i class="fa fa-times mr-1"></i> {{ canEdit ? 'Cancelar' : 'Fechar' }}
          </b-button>
          <b-button v-if="canEdit" variant="primary" @click="onOk" class="btn-glass-primary px-4 font-weight-bold">
            <i class="fa fa-check mr-1"></i> Gravar Volume
          </b-button>
        </div>
      </b-form>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'NfeTranspVolumeModal',
  props: {
    volume: { type: Object, default: () => null },
    nfeId: { type: Number, default: null },
    modalId: { type: String, required: true },
    canEdit: { type: Boolean, default: true }
  },
  data() {
    return {
      show: false,
      local: this.initialLocal(),
      errors: {}
    }
  },
  computed: {
    isEditMode() {
      return this.volume && this.volume.ID
    },
    title() {
      return this.isEditMode ? 'Alterar Volume' : 'Incluir Volume'
    }
  },
  watch: {
    volume: { handler() { this.local = this.initialLocal() }, deep: true }
  },
  methods: {
    mostrar() {
      this.local = this.initialLocal()
      this.$refs.modal.show()
    },
    initialLocal() {
      const v = this.volume || {}
      return {
        ID: v.ID || null,
        NR_QUANTIDADE: v.NR_QUANTIDADE || 1,
        TX_ESPECIE: v.TX_ESPECIE || '',
        TX_MARCA: v.TX_MARCA || '',
        TX_NUMERACAO: v.TX_NUMERACAO || '',
        NR_PESO_LIQUIDO: v.NR_PESO_LIQUIDO || 0,
        NR_PESO_BRUTO: v.NR_PESO_BRUTO || 0
      }
    },
    validate() {
      const e = {}
      if (!this.local.NR_QUANTIDADE || Number(this.local.NR_QUANTIDADE) <= 0) {
        e.quantidade = 'Quantidade deve ser maior que zero'
      }
      if (!this.local.TX_ESPECIE || String(this.local.TX_ESPECIE).trim() === '') {
        e.especie = 'Espécie é obrigatória'
      }
      if (this.local.NR_PESO_LIQUIDO != null && Number(this.local.NR_PESO_LIQUIDO) < 0) {
        e.pesoLiquido = 'Peso líquido inválido'
      }
      if (this.local.NR_PESO_BRUTO != null && Number(this.local.NR_PESO_BRUTO) < 0) {
        e.pesoBruto = 'Peso bruto inválido'
      }
      if (Number(this.local.NR_PESO_LIQUIDO) > 0 && Number(this.local.NR_PESO_BRUTO) > 0) {
        if (Number(this.local.NR_PESO_LIQUIDO) > Number(this.local.NR_PESO_BRUTO)) {
          e.pesoLiquido = 'Peso líquido não pode ser maior que o peso bruto'
        }
      }
      this.errors = e
      return Object.keys(e).length === 0
    },
    onOk(bvModalEvt) {
      if (!this.canEdit) {
        bvModalEvt.preventDefault()
        return
      }
      const ok = this.validate()
      if (!ok) {
        bvModalEvt.preventDefault()
        return
      }
      const out = {
        ID: this.local.ID,
        ID_NFE: this.nfeId,
        NR_QUANTIDADE: Number(this.local.NR_QUANTIDADE),
        TX_ESPECIE: this.local.TX_ESPECIE,
        TX_MARCA: this.local.TX_MARCA,
        TX_NUMERACAO: this.local.TX_NUMERACAO,
        NR_PESO_LIQUIDO: Number(this.local.NR_PESO_LIQUIDO || 0),
        NR_PESO_BRUTO: Number(this.local.NR_PESO_BRUTO || 0)
      }
      this.$emit('salvar', out)
    },
    onHidden() { this.$emit('closed') }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeTranspVolumeModal.vue